import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import * as formatter from 'mt-react-common/utils/formatter';

// eslint-disable-next-line react/prefer-stateless-function
class UserReferralTableItem extends Component {
  render() {
    return (
      <tr>
        <td className="td-main">
          <NavLink to={`/users/profile/${this.props.item.referralId}`}>
            <i className="fa fa-user" /> {this.props.item.referralUserName}
          </NavLink>
        </td>
        <td className="td-desc text-center">
          {formatter.dateFormat3(this.props.item.regAt)}
        </td>
        <td className="text-warning text-center">{this.props.item.level}</td>
        <td className="text-success text-right">{this.props.item.money}</td>
      </tr>
    );
  }
}

UserReferralTableItem.propTypes = {
  item: PropTypes.shape({
    referralId: PropTypes.number.isRequired,
    referralUserName: PropTypes.string.isRequired,
    regAt: PropTypes.string.isRequired,
    level: PropTypes.number.isRequired,
    money: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(UserReferralTableItem);



// WEBPACK FOOTER //
// ./src/components/UserReferral/UserReferralTable/UserReferralTableItem.js